import { render, staticRenderFns } from "./UserSetting.vue?vue&type=template&id=a72a11f6&"
import script from "./UserSetting.vue?vue&type=script&lang=js&"
export * from "./UserSetting.vue?vue&type=script&lang=js&"
import style0 from "./UserSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports